import { Component, ViewChild } from "@angular/core";
import { IonicPage, NavController, NavParams, ModalController, AlertController, LoadingController } from "ionic-angular";

import { AuthProvider } from "../../providers/auth/auth";
import { DatabaseProvider } from "../../providers/database/database";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/mergeMap";
import * as _ from "lodash";
import { PatientDetailsPage } from "../patient-details/patient-details";
import { Subject } from 'rxjs/Subject';
import { Storage } from "@ionic/storage";
import { OrderProvider } from "../../providers/order/order";
import { UtilityProvider } from "../../providers/utility/utility";
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as XLSX from 'xlsx';
import { PatientAddEditPage } from "../patient-add-edit/patient-add-edit";

@IonicPage()
@Component({
  selector: "page-patients",
  templateUrl: "patients.html"
})
export class PatientsPage {
  private ngUnsubscribe: Subject<any> = new Subject();

  displayedColumns = ['program_patient_id', 'last_name', 'first_name', 'therapy', 'indication', 'status', 'substatus', 'drugtype', 'doctor_name','clinic_name','task_button'];
  dataSource: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  public patientList: Observable<any[]>;
  program_id: string;
  program_name: string;
  user: any;
  searchTerm: string;
  searchType: string;
  indications: any[] = [];
  filteredpatients: any[] = [];
  patients: any[] = [];
  isLoading = false;
  exportjson: any[] = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private readonly auth: AuthProvider,
    public database: DatabaseProvider,
    public utility: UtilityProvider
  ) {
  }


  ionViewWillEnter()  {
    this.getUserClinics();
  }

  async getUserClinics()  {
    return new Promise((resolve, reject) => {
      this.auth.getCurrentUser().then(async user => {
        this.user = { id: user.id, name: user.first_name + ' ' + user.last_name };
        this.program_name = user.program_name;
        this.program_id = user.program_id;

        this.auth.getCurrentUser().then(user => {
          this.program_name = user.program_name;
          this.program_id = user.program_id;
    
          this.database
            .getPatientsByProgram(this.program_id)
            .snapshotChanges()
            .map(actions => {
              return actions.map(a => {
                const data = a.payload.doc.data() as any;
                data.id = a.payload.doc.id;
                return data;
              });
            })
            .takeUntil(this.ngUnsubscribe)
            .subscribe((patients) => {
              let pats = [];
              patients.forEach(item => {
                item['clinic_name'] = item.clinic ? item.clinic.name : null;
                item['doctor_name'] = (item.doctor ? item.doctor.first_name : '') + ' ' + (item.doctor ? item.doctor.last_name : '');
                item['drugtype'] = this.utility.getDrugType(item.reimbursement_private, item.reimbursement_private_other, item.reimbursement_public, item.reimbursement_compassionate);
                item['reimbursementtype'] = this.utility.getReimbursementType(item.reimbursement_private, item.reimbursement_private_other, item.reimbursement_public, item.reimbursement_compassionate, item.reimbursement_fa);
                item['activeinactive'] = this.utility.getReimbursementActiveType(item.reimbursement_private, item.reimbursement_private_other, item.reimbursement_public);
                pats.push(item);
              })
              this.exportjson = pats;
              this.dataSource = new MatTableDataSource(pats);
              this.dataSource.paginator = this.paginator;
              this.dataSource.sort = this.sort;
              resolve();
            });
        });
      });
    });
  }

  ngOnDestroy() {
    console.log('Leaving patient list view and destroying subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  showPatientDetail(patient) {
    let patientdata = {
      patient: patient
    };
    this.navCtrl.push(PatientDetailsPage, patientdata);
  }

  filterItems(searchTerm) {
    return this.patients.filter(patient => {
      return (
        patient[this.searchType].toLowerCase().indexOf(searchTerm.toLowerCase()) > -1
      );
    });
  }

  exportPatients() {

    const workBook = XLSX.utils.book_new(); // create a new blank book
    const workSheet = XLSX.utils.json_to_sheet(this.exportjson);

    XLSX.utils.book_append_sheet(workBook, workSheet, 'Patients'); // add the worksheet to the book
    XLSX.writeFile(workBook, 'patients.xlsx'); // initiate a file download in browser
  }

  viewPatient(patient_id)  {
    this.navCtrl.push(PatientDetailsPage, { 'patient_id': patient_id });
  }

  editPatient(patient_id)  {
    this.navCtrl.push(PatientAddEditPage, { 'patient_id': patient_id });
  }
}



// WEBPACK FOOTER //
// ./src/pages/patients/patients.ts